module.exports = __webpack_public_path__ + "static/opinion-f13c34b0fff65bf31304031233c8f9fc.png";